"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var react_router_dom_1 = require("react-router-dom");
var react_redux_1 = require("react-redux");
var formik_1 = require("formik");
var classnames_1 = __importDefault(require("classnames"));
var postSlice_1 = require("../../../features/post/postSlice");
var AppFooter_1 = __importDefault(require("../../../components/AppFooter/AppFooter"));
var globalSlice_1 = require("../../../features/global/globalSlice");
var savePostSchema_1 = __importDefault(require("../../../schemas/savePostSchema"));
var schemaSlice_1 = require("../../../features/post/schemaSlice");
var publishPostSchema_1 = require("../../../schemas/post/publishPostSchema");
var FormSteps_1 = __importDefault(require("./FormSteps"));
var Routes_1 = require("../../../constants/Routes");
var PageLoader_1 = __importDefault(require("../../../components/PageLoader"));
var PostForm_1 = __importDefault(require("./PostForm"));
var userSlice_1 = require("../../../features/user/userSlice");
var GeneralSettings_1 = require("../../../constants/GeneralSettings");
var auth_1 = require("../../../helpers/auth");
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var FORM_ACTIONS = {
    SAVE: 'save',
    PUBLISH: 'publish',
    PREVIEW: 'preview',
};
var NewPostForm = function () {
    var t = react_i18next_1.useTranslation('common').t;
    var dispatch = react_redux_1.useDispatch();
    var history = react_router_dom_1.useHistory();
    var id = react_router_dom_1.useParams().id;
    var steps = react_redux_1.useSelector(schemaSlice_1.selectPostSections);
    var post = react_redux_1.useSelector(postSlice_1.selectPost(id));
    var hasPermission = react_redux_1.useSelector(postSlice_1.selectHasPermission(id));
    var initialValues = react_redux_1.useSelector(postSlice_1.selectInitialValues(id));
    var user = react_redux_1.useSelector(userSlice_1.useSelectUser);
    var loading = react_redux_1.useSelector(postSlice_1.selectLoading);
    var _a = react_1.useState(FORM_ACTIONS.SAVE), formAction = _a[0], setFormAction = _a[1];
    var _b = react_1.useState(false), isApartmentFormSubmitted = _b[0], setIsApartmentFormSubmitted = _b[1];
    var _c = react_1.useState(''), collapsedApartmentId = _c[0], setCollapsedApartmentId = _c[1];
    var _d = react_1.useState(false), isSaveButtonClicked = _d[0], setIsSaveButtonClicked = _d[1];
    react_1.useEffect(function () {
        init();
    }, []);
    react_1.useEffect(function () {
        setIsApartmentFormSubmitted(false);
    }, [collapsedApartmentId]);
    react_1.useEffect(function () {
        if (hasPermission === false) {
            history.push(Routes_1.Routes.Home.path);
        }
    }, [post, user]);
    var init = function () { return __awaiter(void 0, void 0, void 0, function () {
        var e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    dispatch(schemaSlice_1.getPostSchema());
                    return [4 /*yield*/, dispatch(postSlice_1.getPost(id))];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 3];
                case 2:
                    e_1 = _a.sent();
                    dispatch(globalSlice_1.setIsPageNotFound(true));
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var validationSchema = function () {
        // If post is already published, we should validate all fields upon save as well
        if (post.publishedAt ||
            formAction === FORM_ACTIONS.PUBLISH ||
            isApartmentFormSubmitted) {
            return publishPostSchema_1.getValidationSchema(post.isDeveloper, isApartmentFormSubmitted, collapsedApartmentId, post.publishedAt, isSaveButtonClicked);
        }
        return savePostSchema_1.default;
    };
    var handleSubmitApartmentForm = function (submitForm, apartment) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, setIsApartmentFormSubmitted(true)];
                case 1:
                    _a.sent();
                    setCollapsedApartmentId(apartment.entity_id);
                    return [4 /*yield*/, submitForm()];
                case 2:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var onSubmit = function (values, resetForm) { return __awaiter(void 0, void 0, void 0, function () {
        var postData, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    postData = __assign({}, values);
                    if (post.isDeveloper) {
                        postData.apartment_info = values.apartment_info.filter(function (apartment) { return apartment.id === collapsedApartmentId; });
                    }
                    _a = !isApartmentFormSubmitted;
                    if (!_a) return [3 /*break*/, 2];
                    return [4 /*yield*/, savePost(postData)];
                case 1:
                    _a = (_b.sent());
                    _b.label = 2;
                case 2:
                    _a;
                    resetForm({ values: values });
                    setIsApartmentFormSubmitted(false);
                    if (!isApartmentFormSubmitted) {
                        if (formAction === FORM_ACTIONS.SAVE) {
                            dispatch(globalSlice_1.addToastMessage({
                                text: t('POST_SCREEN.SAVE_SUCCESS'),
                                appearance: 'success',
                            }));
                            history.push("/account/announcements");
                        }
                        if (formAction === FORM_ACTIONS.PUBLISH) {
                            publishPostHandler(id);
                        }
                        else if (formAction === FORM_ACTIONS.PREVIEW) {
                            history.push("/account/announcements/preview/" + id);
                        }
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var publishPostHandler = function (id) { return __awaiter(void 0, void 0, void 0, function () {
        var e_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, dispatch(postSlice_1.publishPost(id))];
                case 1:
                    _a.sent();
                    dispatch(globalSlice_1.addToastMessage({
                        text: t('POST_SCREEN.PUBLISH_SUCCESS'),
                        appearance: 'success',
                    }));
                    history.push("/account/announcements");
                    return [3 /*break*/, 3];
                case 2:
                    e_2 = _a.sent();
                    dispatch(globalSlice_1.addToastMessage({
                        text: t('ERRORS.POST_CREATE_FAILURE'),
                        appearance: 'error',
                    }));
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var save = function (formikProps) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, setFormAction(FORM_ACTIONS.SAVE)];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, setIsApartmentFormSubmitted(false)];
                case 2:
                    _a.sent();
                    return [4 /*yield*/, setIsSaveButtonClicked(true)];
                case 3:
                    _a.sent();
                    return [4 /*yield*/, formikProps.submitForm()];
                case 4:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var publish = function (formikProps) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, setFormAction(FORM_ACTIONS.PUBLISH)];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, setIsApartmentFormSubmitted(false)];
                case 2:
                    _a.sent();
                    return [4 /*yield*/, setIsSaveButtonClicked(true)];
                case 3:
                    _a.sent();
                    return [4 /*yield*/, formikProps.submitForm()];
                case 4:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var preview = function (formikProps) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, setFormAction(FORM_ACTIONS.PREVIEW)];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, formikProps.submitForm()];
                case 2:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var reset = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            history.push(Routes_1.Routes.Account.path);
            return [2 /*return*/];
        });
    }); };
    var savePost = function (values) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, media, rest, post_1, e_3;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = values.about_building, media = _a.media, rest = __rest(_a, ["media"]);
                    if (!auth_1.getIsFavoriteUser()) {
                        values.initial_info.is_favorite = null;
                    }
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, dispatch(postSlice_1.updatePost(id, __assign(__assign({}, values), { apartment_info: values.apartment_info.map(function (_a) {
                                var media = _a.media, rest = __rest(_a, ["media"]);
                                return rest;
                            }), about_building: rest })))];
                case 2:
                    post_1 = (_b.sent()).post;
                    return [2 /*return*/, post_1];
                case 3:
                    e_3 = _b.sent();
                    dispatch(globalSlice_1.addToastMessage({
                        text: t('ERRORS.POST_CREATE_FAILURE'),
                        appearance: 'error',
                    }));
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: classnames_1.default('main-content with-sidebar', styles_module_scss_1.default.new_post) },
            loading && react_1.default.createElement(PageLoader_1.default, null),
            react_1.default.createElement("div", { className: "container" },
                react_1.default.createElement("div", { className: classnames_1.default(styles_module_scss_1.default.sidebar, 'left') },
                    react_1.default.createElement(FormSteps_1.default, null)),
                react_1.default.createElement("div", { className: "content" },
                    react_1.default.createElement("h2", { className: "page-title text-uppercase" }, t((post === null || post === void 0 ? void 0 : post.status) === GeneralSettings_1.POST_STATUSES.DRAFT
                        ? 'POST_SCREEN.TITLE.NEW_POST'
                        : 'POST_SCREEN.TITLE.EDIT_POST')),
                    hasPermission && !!steps.length && (react_1.default.createElement(formik_1.Formik, { initialValues: initialValues, validationSchema: validationSchema(), onSubmit: function (values, _a) {
                            var resetForm = _a.resetForm;
                            return onSubmit(values, resetForm);
                        }, validateOnBlur: true }, function (formikProps) { return (react_1.default.createElement(PostForm_1.default, { formikProps: formikProps, steps: steps, post: post, preview: preview, publish: publish, save: save, reset: reset, handleSubmitApartmentForm: handleSubmitApartmentForm, isApartmentFormSubmitted: isApartmentFormSubmitted, setCollapsedApartmentId: setCollapsedApartmentId, collapsedApartmentId: collapsedApartmentId, setIsApartmentFormSubmitted: setIsApartmentFormSubmitted })); }))))),
        react_1.default.createElement(AppFooter_1.default, null)));
};
exports.default = NewPostForm;
